/// <reference path="skyward.ui.expandingLabel.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.expandingLabel = skyward.expandingLabel || {};

        var show = function (expandingParagraph)
        {
            expandingParagraph.addClass('visibleMode');
            expandingParagraph.removeClass('hiddenMode');
        };

        var hide = function (expandingParagraph)
        {
            expandingParagraph.addClass('hiddenMode');
            expandingParagraph.removeClass('visibleMode');
        };

        var init = function (selector)
        {
            $(selector).find('.expandingParagraph').each(function ()
            {
                var expandingParagraph = $(this);
                expandingParagraph.on('click', '.expandingParagraphButton', function ()
                {
                    var button = $(this);
                    if (button.data().action == 'show')
                    {
                        show(expandingParagraph);
                    }
                    else
                    {
                        hide(expandingParagraph);
                    }
                });
            });
        };

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);